import React, { forwardRef, useContext, useState } from 'react';
import styled from 'styled-components';
import { FormRowStyle } from './FormRow.styles.js';
import { FormContext } from '../Form/FormContext.js';
import { FormRowContext } from './FormRowContext.js';

const _FormRow = forwardRef((props, ref) => {
    const { className, alternative, rounding, sizing, children } = props;
    const formContext = useContext(FormContext);
    const [id, setId] = useState();
    const [group, setGroup] = useState(false);
    const register = ({ group, id }) => {
        if (id === undefined || id.length === 0) {
            throw new Error('FormRow: register() was called without giving an id as an argument.');
        }
        setId(id);
        setGroup(!!group);
    };
    const Tag = group ? 'fieldset' : 'div';
    return (React.createElement(Tag, { className: className, ref: ref },
        React.createElement(FormRowContext.Provider, { value: {
                alternative: alternative !== null && alternative !== void 0 ? alternative : formContext === null || formContext === void 0 ? void 0 : formContext.alternative,
                group,
                id: id,
                register,
                rounding: rounding !== null && rounding !== void 0 ? rounding : formContext === null || formContext === void 0 ? void 0 : formContext.rounding,
                sizing: sizing !== null && sizing !== void 0 ? sizing : formContext === null || formContext === void 0 ? void 0 : formContext.sizing,
            } }, children)));
});
_FormRow.displayName = '_FormRow';
const FormRow = styled(_FormRow).attrs(props => {
    const formContext = useContext(FormContext);
    return {
        ...formContext,
        ...props,
    };
}) `
    ${FormRowStyle};
`;

export { FormRow };
//# sourceMappingURL=FormRow.js.map
